<div class="nav-type-title">{{ section }}</div>
@if (section === 'Airports') {
  @for (candidate of candidates; track candidate) {
    <div
      class="item"
      (click)="select(candidate)"
      >
      {{ candidate.graphic?.attributes['name'] }} ({{ candidate.id }})
    </div>
  }
}
@if (section !== 'Airports') {
  @for (candidate of candidates; track candidate) {
    <div
      class="item"
      (click)="select(candidate)"
      >
      {{ candidate.id }}
    </div>
  }
}
